const getFocusable = (el: HTMLElement) => {
	const focusable = el.querySelectorAll<HTMLElement>(
		'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])',
	);

	const first = focusable[0];
	const last = focusable[focusable.length - 1];

	return [first, last];
};

export default getFocusable;
